import { COMPLETED } from 'customer-data-objects/engagement/EngagementStatusTypes';
import { getProperty } from 'customer-data-objects/model/ImmutableModel';
import { DUE_DATE, IS_ALL_DAY, STATUS } from 'customer-data-objects/task/TaskPropertyNames';
import TimezoneTypes from 'I18n/constants/TimezoneTypes';
import UITruncateString from 'UIComponents/text/UITruncateString';
import { isTaskOverdue } from '../../utils/isTaskOverdue';
import DateTimeCell from './DateTimeCell';
import { View } from 'foundations-components/components/View';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
const TaskDueDateCell = ({
  original: cdtTask
}) => {
  const dueDate = getProperty(cdtTask, DUE_DATE);
  const isAllDay = getProperty(cdtTask, IS_ALL_DAY);
  const dateFormat = isAllDay ? 'll' : 'LLL';
  const isOverdue = isTaskOverdue(cdtTask);
  const isTaskComplete = getProperty(cdtTask, STATUS) === COMPLETED;
  const formattedDate = /*#__PURE__*/_jsx(DateTimeCell, {
    format: dateFormat,
    i18nTimezoneType: TimezoneTypes.USER,
    value: dueDate
  });
  return /*#__PURE__*/_jsx(View, {
    "data-test-id": "task-due-date-cell",
    children: /*#__PURE__*/_jsx(Text, {
      color: isOverdue && !isTaskComplete ? 'fill-alert-default' : undefined,
      children: /*#__PURE__*/_jsx(UITruncateString, {
        children: formattedDate
      })
    })
  });
};
export default TaskDueDateCell;